export const semanticColors = {
	night: '#233A47',
	default: '#f7f7f7',
	primary: '#385C70',
	primaryLight: '#CDD6DB',
	primaryDark: '#27404e',
	success: '#15B597',
	successLight: '#c5ece5 ',
	info: '#5AA6C2',
	infoLight: '#A8CEDC',
	infoLighter: '#E6EEF0',
	infoHover: '#5aa6c2',
	warning: '#F19A00',
	warningLight: '#fae0b2',
	danger: '#DD534C',
	dangerLight: '#f6d4d2',
	dangerLighter: '#fbeded ',
	mainBackground: '#9badb7',
	mainBackground2: '#EBEEF0',
	text: '#4a4a4a',
}

export const greyScaleColors = {
	greyDarker: '#222222',
	greyDark: '#333333',
	grey: '#555555',
	greyLight: '#777777',
	greyLighter: '#EEEEEE'
}



// WEBPACK FOOTER //
// ./src/App/Globals/styles.js